import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageBoxComponent } from '../routed-modules/incidents/modals/message-box/message-box.component';
import { LocationDropdownComponent } from './dropdowns/location-dropdown/location-dropdown.component';
import { UserDropdownComponent } from './dropdowns/user-dropdown/user-dropdown.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StaffPhotoComponent } from '../components/staff/staff-photo/staff-photo.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea'
import { RadioButtonModule } from 'primeng/radiobutton';
import { ClipboardModule } from 'ngx-clipboard';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { PanelModule } from 'primeng/panel'
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast'
import { TagModule } from 'primeng/tag'
import { ToolbarModule } from 'primeng/toolbar'
import { AutoCompleteModule } from 'primeng/autocomplete';
import { EditInPlaceComponent } from './edit-in-place/edit-in-place.component'
import { InplaceModule } from 'primeng/inplace';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { TripDropdownComponent } from './dropdowns/trip-dropdown/trip-dropdown.component';
import { CheckboxModule } from 'primeng/checkbox'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { DividerModule } from 'primeng/divider';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip'
import { TableModule } from 'primeng/table';
import { DynamicFormFieldComponent } from './dynamic-form/dynamic-form-field/dynamic-form-field.component';
import { FormControlPipe } from './dynamic-form/formControl.pipe';
import { DragDropModule } from 'primeng/dragdrop'
import { InputNumberModule } from 'primeng/inputnumber';
import { LinkEditFormComponent } from './dynamic-form/link-edit-form/link-edit-form.component';
import { DynamicOptionFormComponent } from './dynamic-form/dynamic-option-form/dynamic-option-form.component';
import { CustomerFieldEditComponent } from './customer-field-edit/customer-field-edit.component';
import { ToStringPipe } from './pipes/to-string.pipe';
import { CompleteChipComponent } from './complete-chip/complete-chip.component';
import { TripFieldEditComponent } from './trip-field-edit/trip-field-edit.component';
import { StaffDisplayPipe } from './pipes/staff-display.pipe';
import { FlightDirectionPipe } from './pipes/flight-direction.pipe';
import { ContactCardUrlPipe } from './pipes/contact-card-url.pipe';
import { DynamicComponentPipe } from './pipes/dynamic-component.pipe';
import { UtilityModule } from '../utility/utility.module';
import { DialogModule } from 'primeng/dialog'
import { DynamicDialogModule } from 'primeng/dynamicdialog'
import { MessageModule } from 'primeng/message'
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { DropdownOptionPipe } from './pipes/dropdown-option.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { DateTimePipe } from './pipes/date-time.pipe';
import { SanitizeHtmlPipe } from './pipes/safe-html.pipe';
import { ScrollTopModule } from 'primeng/scrolltop';
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { LocationDisplayPipe } from './pipes/location-display.pipe';
import { EditLocationInPlaceComponent } from './edit-in-place/edit-location-in-place/edit-location-in-place.component';
import { EditStaffInPlaceComponent } from './edit-in-place/edit-staff-in-place/edit-staff-in-place.component';
import { OfficeDropdownComponent } from './dropdowns/office-dropdown/office-dropdown.component';
import { EditOfficeInPlaceComponent } from './edit-in-place/edit-office-in-place/edit-office-in-place.component';
import { OfficeDisplayPipe } from './pipes/office-display.pipe';
import { AirportDropdownComponent } from './dropdowns/airport-dropdown/airport-dropdown.component';
import { EditAircodeInPlace } from './edit-in-place/edit-airport-in-place/edit-aircode-in-place.component';
import { AirportDisplayPipe } from './pipes/airport-display.pipe';
import { AircodeDropdownComponent } from './dropdowns/aircode-dropdown/aircode-dropdown.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PartnerDropdownComponent } from './dropdowns/partner-dropdown/partner-dropdown.component';
import { CommunityDropdownComponent } from './dropdowns/community-dropdown/community-dropdown.component';
import { ContactDropdownComponent } from './dropdowns/contact-dropdown/contact-dropdown.component';
import { IconSwitchComponent } from './icon-switch/icon-switch.component'
import { TooltipModule } from 'primeng/tooltip';
import { ParticipantNameDisplayPipe } from './pipes/participant-name-display.pipe';
import { DataPadComponent } from './data-pad/data-pad.component';
import { DynamicModule } from 'ng-dynamic-component';
import { SaveButtonComponent } from './save-button/save-button.component';
import { SelectByIdPipe } from './pipes/select-by-id.pipe';
import { DataPadCardHeaderComponent } from './data-pad/data-pad-card-header/data-pad-card-header.component';
import { ContactNameDisplayPipe } from './pipes/contact-name-display.pipe';
import { LinkButtonComponent } from './link-button/link-button.component';
import { StaffDropdownMultiComponent } from './staff-dropdown-multi/staff-dropdown-multi.component';
import { MultiSelectModule } from "primeng/multiselect";
import { StaffDropdownComponent } from './staff-dropdown/staff-dropdown.component'
import { ProfilesLocationDropdownComponent } from './dropdowns/profiles-location-dropdown/profiles-location-dropdown.component'
import { InputMaskModule } from 'primeng/inputmask';
import { PhoneTypeIconComponent } from './phone-type-icon/phone-type-icon.component';
import { AutoFocusModule } from 'primeng/autofocus';
import { CustomerContactDropdownComponent } from './dropdowns/customer-contact-dropdown/customer-contact-dropdown.component';
import { TripDetailDisplayPipe } from './pipes/trip-detail-display.pipe';
import { TripJournalLinkPipe } from './trip-journal-link.pipe'
import { AccordionModule } from 'primeng/accordion';
import { NgxEditorModule } from 'ngx-editor';
import { SkeletonModule } from 'primeng/skeleton';
import { GenderPipe } from './pipes/gender.pipe';
import { TripDropdown2Component } from './dropdowns/trip-dropdown2/trip-dropdown2.component';
import { PartnerContactDropdownComponent } from './dropdowns/partner-contact-dropdown/partner-contact-dropdown.component';
import { PartnerTripDropdownComponent } from './dropdowns/partner-trip-dropdown/partner-trip-dropdown.component';
import { ProseMirrorComponent } from './prose-mirror/prose-mirror.component';
import { LocationMultiDropdownComponent } from './dropdowns/location-multi-dropdown/location-multi-dropdown.component';
import { SubtripFieldEditComponent } from './subtrip-field-edit/subtrip-field-edit.component';
import { RootsPartnerLinkPipe } from './pipes/roots-partner-link.pipe';
import { AircodeDisplayPipe } from './pipes/aircode-display.pipe';
import { TripFlagPipe } from './pipes/trip-flag.pipe';
import { TripFinanceStatementDetailEditComponent } from './trip-finance-statement-detail-edit/trip-finance-statement-detail-edit.component'
import { EditToggleDirective } from './edit-in-place/edit-toggle.directive';
import { SelectedRowDirective } from './directives/selected-row.directive';
import { BirthdayPickerComponent } from './birthday-picker/birthday-picker.component';
import { AgePipe } from './pipes/age.pipe';
import { RxFor } from '@rx-angular/template/for';
import { TableRowDirective } from './utility/table-row.directive';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AvatarModule } from 'primeng/avatar';
import { DisasterDisplayPipe } from './pipes/disaster-display.pipe';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SpecialtyDisplayPipe } from './pipes/specialty-display.pipe';
import { DataViewModule } from 'primeng/dataview';
import { RatingModule } from 'primeng/rating';
import { KpiRoleNamePipe } from './pipes/kpi-role-name.pipe';
import { MeterGroupModule } from 'primeng/metergroup';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { BackgroundCheckTypePipe } from './pipes/background-check-type.pipe';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { TabsModule } from 'primeng/tabs'
import { PopoverModule } from 'primeng/popover'
import { DatePickerModule } from 'primeng/datepicker';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { KnobModule } from 'primeng/knob';
import { SplitterModule } from 'primeng/splitter';
import { CustomerDropdownComponent } from './dropdowns/customer-dropdown/customer-dropdown.component';
import { ItineraryUrlPipe } from '../component-modules/trip-components/pipes/itinerary-url.pipe';
import { TableColumnComponent } from './tables/table-column/table-column.component';
import { TableHeaderComponent } from './tables/table-header/table-header.component';
import { TableHeadersComponent } from './tables/table-headers/table-headers.component';
import { TableColumnsComponent } from './tables/table-columns/table-columns.component';
import {EditTagsInPlaceComponent} from './edit-in-place/edit-tags-in-place/edit-tags-in-place.component'
import { OpsRegionDropdownComponent } from './dropdowns/ops-region-dropdown/ops-region-dropdown.component';
import { EditOpsRegionInPlaceComponent } from './edit-in-place/edit-ops-region-in-place/edit-ops-region-in-place.component';
import { OpsRegionSingleDropdownComponent } from './dropdowns/ops-region-single-dropdown/ops-region-single-dropdown.component';
import { OpsRegionDisplayPipe } from './pipes/ops-region-display.pipe';
import { PartnerLogNoteCategoryPipe } from './pipes/partner-log-note-category.pipe';
import { RootsEditInPlaceComponent } from './roots-edit-in-place/roots-edit-in-place.component';
import { RootsFieldEditComponent } from './roots-field-edit/roots-field-edit.component';

@NgModule({
  declarations: [
    MessageBoxComponent,
    UserDropdownComponent,
    EditInPlaceComponent,
    TripDropdownComponent,
    DynamicFormFieldComponent,
    FormControlPipe,
    LinkEditFormComponent,
    DynamicOptionFormComponent,
    CustomerFieldEditComponent,
    CompleteChipComponent,
    TripFieldEditComponent,
    FlightDirectionPipe,
    DynamicComponentPipe,
    DropdownOptionPipe,
    DateTimePipe,
    EditLocationInPlaceComponent,
    EditStaffInPlaceComponent,
    EditOfficeInPlaceComponent,
    EditOpsRegionInPlaceComponent,
    OfficeDisplayPipe,
    EditAircodeInPlace,
    AirportDisplayPipe,
    AircodeDropdownComponent,
    PartnerDropdownComponent,
    CommunityDropdownComponent,
    ContactDropdownComponent,
    IconSwitchComponent,
    DataPadComponent,
    PhoneTypeIconComponent,
    CustomerContactDropdownComponent,
    TripDetailDisplayPipe,
    GenderPipe,
    TripDropdown2Component,
    PartnerContactDropdownComponent,
    PartnerTripDropdownComponent,
    SubtripFieldEditComponent,
    RootsPartnerLinkPipe,
    AircodeDisplayPipe,
    TripFinanceStatementDetailEditComponent,
    EditToggleDirective,
    SelectedRowDirective,
    KpiRoleNamePipe,
    SafeUrlPipe,
    CustomerDropdownComponent,
    EditTagsInPlaceComponent,
    RootsEditInPlaceComponent,
    RootsFieldEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    RadioButtonModule,
    TextareaModule,
    ClipboardModule,
    FileUploadModule,
    ImageModule,
    PanelModule,
    ProgressBarModule,
    ToastModule,
    TagModule,
    ToolbarModule,
    AutoCompleteModule,
    InplaceModule,
    FontAwesomeModule,
    CheckboxModule,
    ScrollPanelModule,
    DividerModule,
    CardModule,
    ChipModule,
    TableModule,
    DragDropModule,
    InputNumberModule,
    UtilityModule,
    DialogModule,
    DynamicDialogModule,
    MessageModule,
    MenuModule,
    ContextMenuModule,
    ScrollTopModule,
    ProgressSpinnerModule,
    TooltipModule,
    DynamicModule,
    MultiSelectModule,
    InputMaskModule,
    AutoFocusModule,
    ClipboardModule,
    AccordionModule,
    NgxEditorModule,
    SkeletonModule,
    BirthdayPickerComponent,
    AgePipe,
    RxFor,
    ContactCardUrlPipe,
    ProseMirrorComponent,
    TableRowDirective,
    TieredMenuModule,
    PanelMenuModule,
    BreadcrumbModule,
    AvatarModule,
    DisasterDisplayPipe,
    SelectButtonModule,
    SaveButtonComponent,
    SpecialtyDisplayPipe,
    AgePipe,
    DataViewModule,
    RatingModule,
    MeterGroupModule,
    BackgroundCheckTypePipe,
    SanitizeHtmlPipe,
    ToggleSwitchModule,
    TabsModule,
    SelectModule,
    PopoverModule,
    DatePickerModule,
    IconButtonComponent,
    ContactCardUrlPipe,
    TripFlagPipe,
    StaffDisplayPipe,
    LocationMultiDropdownComponent,
    LocationDisplayPipe,
    StaffDropdownMultiComponent,
    ParticipantNameDisplayPipe,
    DataPadCardHeaderComponent,
    IconFieldModule,
    InputIconModule,
    ConfirmDialog,
    LocationDropdownComponent,
    OfficeDropdownComponent,
    AirportDropdownComponent,
    FieldsetModule,
    KnobModule,
    SplitterModule,
    ItineraryUrlPipe,
    LinkButtonComponent,
    TableColumnComponent,
    TableHeaderComponent,
    TableHeadersComponent,
    TableColumnsComponent,
    StaffPhotoComponent,
    ToStringPipe,
    StaffDropdownComponent,
    ProfilesLocationDropdownComponent,
    YesNoPipe,
    TripJournalLinkPipe,
    ContactNameDisplayPipe,
    SelectByIdPipe,
    OpsRegionDropdownComponent,
    OpsRegionSingleDropdownComponent,
    OpsRegionDisplayPipe,
    TimeAgoPipe,
    PartnerLogNoteCategoryPipe
  ],
  exports: [
    MessageBoxComponent,
    LocationDropdownComponent,
    UserDropdownComponent,
    StaffPhotoComponent,
    ButtonModule,
    InputTextModule,
    DatePickerModule,
    RadioButtonModule,
    FileUploadModule,
    ImageModule,
    PanelModule,
    ProgressBarModule,
    ToastModule,
    TagModule,
    ToolbarModule,
    AutoCompleteModule,
    EditInPlaceComponent,
    IconButtonComponent,
    TripDropdownComponent,
    CheckboxModule,
    ScrollPanelModule,
    DividerModule,
    CardModule,
    ChipModule,
    TableModule,
    DynamicFormFieldComponent,
    DragDropModule,
    FontAwesomeModule,
    InplaceModule,
    InputNumberModule,
    LinkEditFormComponent,
    DynamicOptionFormComponent,
    CompleteChipComponent,
    TripFieldEditComponent,
    RootsEditInPlaceComponent,
    RootsFieldEditComponent,
    StaffDisplayPipe,
    FlightDirectionPipe,
    ContactCardUrlPipe,
    TextareaModule,
    FormControlPipe,
    ReactiveFormsModule,
    FormsModule,
    DynamicComponentPipe,
    ToStringPipe,
    DialogModule,
    DynamicDialogModule,
    MessageModule,
    MenuModule,
    ContextMenuModule,
    CustomerFieldEditComponent,
    YesNoPipe,
    TimeAgoPipe,
    DateTimePipe,
    ScrollTopModule,
    ProgressSpinnerModule,
    OfficeDisplayPipe,
    LocationDisplayPipe,
    EditAircodeInPlace,
    PartnerDropdownComponent,
    OfficeDropdownComponent,
    CommunityDropdownComponent,
    ContactDropdownComponent,
    IconSwitchComponent,
    TooltipModule,
    EditStaffInPlaceComponent,
    EditLocationInPlaceComponent,
    ParticipantNameDisplayPipe,
    DataPadComponent,
    SaveButtonComponent,
    SelectByIdPipe,
    DataPadCardHeaderComponent,
    ContactNameDisplayPipe,
    LinkButtonComponent,
    StaffDropdownMultiComponent,
    StaffDropdownComponent,
    ProfilesLocationDropdownComponent,
    MultiSelectModule,
    InputMaskModule,
    PhoneTypeIconComponent,
    AutoFocusModule,
    AircodeDropdownComponent,
    CustomerContactDropdownComponent,
    TripDetailDisplayPipe,
    ClipboardModule,
    TripJournalLinkPipe,
    AccordionModule,
    SkeletonModule,
    GenderPipe,
    TripDropdown2Component,
    PartnerContactDropdownComponent,
    PartnerTripDropdownComponent,
    ProseMirrorComponent,
    LocationMultiDropdownComponent,
    SubtripFieldEditComponent,
    RootsPartnerLinkPipe,
    AircodeDisplayPipe,
    TripFlagPipe,
    TripFinanceStatementDetailEditComponent,
    SelectedRowDirective,
    BirthdayPickerComponent,
    AgePipe,
    TableRowDirective,
    TieredMenuModule,
    PanelMenuModule,
    BreadcrumbModule,
    AvatarModule,
    DisasterDisplayPipe,
    SelectButtonModule,
    SpecialtyDisplayPipe,
    AgePipe,
    DataViewModule,
    RatingModule,
    KpiRoleNamePipe,
    MeterGroupModule,
    SafeUrlPipe,
    BackgroundCheckTypePipe,
    SelectModule,
    SanitizeHtmlPipe,
    ToggleSwitchModule,
    TabsModule,
    SelectModule,
    PopoverModule,
    DatePickerModule,
    StaffDropdownMultiComponent,
    IconFieldModule,
    InputIconModule,
    ConfirmDialog,
    FieldsetModule,
    KnobModule,
    SplitterModule,
    CustomerDropdownComponent,
    TableColumnComponent,
    TableHeaderComponent,
    TableHeadersComponent,
    TableColumnsComponent,
    EditTagsInPlaceComponent,
    OpsRegionDropdownComponent,
    OpsRegionSingleDropdownComponent,
    EditOpsRegionInPlaceComponent,
    OpsRegionDisplayPipe,
    PartnerLogNoteCategoryPipe
  ],
  providers: [
    StaffDisplayPipe
  ]
})
export class UiModule { }
